import script from "./ProfilePopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfilePopover.vue?vue&type=script&setup=true&lang=ts"

import "./ProfilePopover.vue?vue&type=style&index=0&id=34a05eb4&lang=css"

const __exports__ = script;

export default __exports__